module.exports = __webpack_public_path__ + "static/media/clockicon.c17e60c9.svg";